import * as React from 'react';
import s from './standalone-header.scss';
import { config } from '../../config';
import { SearchBoxContainer } from '../search-box';
import { HeaderUserDetails } from './header-user-details';
import Search from 'wix-ui-icons-common/Search';
import { useConfigContext } from '../../config-context';
var MobileMenuIcon = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("span", { className: s.mobileMenu, onClick: onClick },
        React.createElement("img", { src: config.marketplaceStaticsUrl + "assets/images/menu.svg" })));
};
export var StandaloneHeader = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, toggleMenu = _a.toggleMenu, toggleSearchBox = _a.toggleSearchBox;
    var locale = useConfigContext().locale;
    return (React.createElement("div", { className: s.header + " " + className },
        React.createElement(MobileMenuIcon, { onClick: toggleMenu }),
        React.createElement("a", { className: s.logoWrapper, href: "/app-market" },
            React.createElement("img", { className: s.logo, src: config.marketplaceStaticsUrl + "assets/images/wix-app-market-new-logo.svg" })),
        React.createElement("div", { className: s.searchUserWrapper },
            React.createElement("span", { className: s.searchIcon },
                React.createElement(Search, { onClick: toggleSearchBox })),
            React.createElement("div", { className: s.searchWrapper },
                React.createElement(SearchBoxContainer, { isInMenu: false, isExpandable: false, isInHeader: true, locale: locale })),
            React.createElement("div", { className: s.verticalDivider }),
            React.createElement(HeaderUserDetails, null))));
};
//# sourceMappingURL=standalone-header.js.map